module.exports = __webpack_public_path__ + "media/images/svg/jobs/air-freight-4f62268cfa68ed7ce0e2c7c6f73fbf84.svg";